import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import React,{useEffect, useState} from 'react';
import useCountDown from 'react-countdown-hook';
import RingTone from './RingTone'


import { Icon, IconAcceptCall, IconRejectCall } from '../../../base/icons';

export interface CallReminderProps {
    callInfo?: Object,
    onAcceptCall?: Function,
    onRejectCall?: Function
}
const initialTime = 60 * 1000; // initial time in milliseconds, defaults to 60000
const interval = 1000;
const CallReminder: FC<CallReminderProps> = props => {
    const { callInfo, onRejectCall, onAcceptCall, closeCallingDialog } = props;

    const [timeLeft, { start, pause, resume, reset }] = useCountDown(initialTime, interval);
    const [counterstart, setCounterStart] = useState(false);

    const handleAccept = () => {
        onAcceptCall();
    };

    const handleReject = () => {
        onRejectCall();
    };
    useEffect(() => {
        start();
        setCounterStart(true)
    }, []);
    useEffect(()=>{
        if(timeLeft==0 &&counterstart ){
            closeCallingDialog()
            setCounterStart(false)
        }
        
    },[timeLeft, counterstart])

    return (
        <ModalTransition>
            <div className = 'popup dis-flex jus-center ali-center'>
                <div className = 'call-reminder dis-flex flex-column jus-evenly'>
                    <h1 className = 'call-reminder-title'>{callInfo?.callerData?.name} is calling you</h1>
                    <div className = 'dis-flex jus-evenly'>
                        <button
                            className = 'call-reminder-btn-call dis-flex flex-column jus-center ali-center'
                            onClick = { handleReject }>
                            <Icon
                                size = { 150 }
                                src = { IconRejectCall } />
                            <span className = 'call-reminder-title-btn'>Decline</span>
                        </button>
                        <button
                            className = 'call-reminder-btn-call dis-flex flex-column jus-center ali-center'
                            onClick = { handleAccept }>
                            <Icon
                                size = { 150 }
                                src = { IconAcceptCall } />
                            <span className = 'call-reminder-title-btn'>Accept</span>
                        </button>
                    </div>
                </div>
            </div>
            <RingTone />
        </ModalTransition>
    );
};

CallReminder.defaultProps = {
    onAcceptCall: () => {},
    onRejectCall: () => {}
};
export default CallReminder;
